import { CourseStatus } from "../enums/CourseStatus.enum";

export const openCourseStatuses = [CourseStatus.Open, CourseStatus.Planned];

export const otherCourseStatuses = (Object.values(CourseStatus) as string[]).filter(
  (x) => x !== CourseStatus.Open && x !== CourseStatus.Planned
);
